/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Copy selected events or text" |
*
* @param {Copy_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_aria_label = /** @type {((inputs?: Copy_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier les evenements ou le texte selectionnes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Ereignisse oder Text kopieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia gli eventi o il testo selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скопировать выбранные события или текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar eventos o texto seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("复制选定的事件或文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントまたはテキストをコピーする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटनाओं या पाठ को कॉपी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar eventos ou texto selecionados")
	return /** @type {LocalizedString} */ ("Copy selected events or text")
});